export default __webpack_public_path__ + "static/media/cross.5f5289f5.svg";